export enum ReportType {
  OrderDetailReport = 1,
  ProductAvailability = 2,
  DealerOrderAudit = 3,
  GrowerOrderAudit = 4,
  TotalOrderSummary = 5,
  ShippableProducts = 6,
  SubstitutionOrderReport = 7,
  ShippingAvailabilityReport = 8,
  SraCostSheetReport = 9,
  SraWuDeliveredCostReport = 10,
  SulfurAndZincReport = 11,
  AMSPricing = 12
}
